import { useEffect, useContext } from 'react';
import { useDispatch } from "react-redux";
import { setBellNotifications } from "../features/bellNotificationsSlice";
import { BellNotificationContext } from "../context/BellNotificationContext";

export default function useBellNotification() {
    const dispatch = useDispatch();
    const { state: bellState } = useContext(BellNotificationContext);
    const bellNotifications = bellState.bellNotifications; // ✅ 取得通知

    useEffect(() => {
        dispatch(setBellNotifications(bellNotifications)); // ✅ 確保 Redux 更新最新的通知
    }, [dispatch, bellNotifications]); // ✅ 加入 `bellNotifications`，讓 Redux 追蹤最新狀態

    return null; // ✅ 不需要回傳值，因為 Redux 已管理通知
};
